import { X } from 'lucide-react';

interface TagProps {
  value: string;
  onRemove: () => void;
  disabled?: boolean;
}

export const Tag = ({ value, onRemove, disabled = false }: TagProps) => {
  return (
    <span className="border-chariot-brand-primary/20 bg-chariot-brand-primary/10 text-chariot-brand-primary inline-flex items-center gap-1 rounded border px-2 py-0.5 text-sm">
      <span>{value}</span>
      {!disabled && (
        <button
          type="button"
          onClick={onRemove}
          className="hover:text-chariot-brand-primary/70 transition-colors"
          aria-label={`Remove ${value}`}
          role="button"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </span>
  );
};
